/**
 * Tenant / API base helpers for authenticated calls.
 */

import { CONFIG, STORAGE_KEYS, isApiConfigured } from "/assets/js/config.js";

/**
 * @returns {{ companyID: string, userEmail: string }}
 */
export function getCompanyContext() {
  return {
    companyID: localStorage.getItem(STORAGE_KEYS.COMPANY_ID) || "",
    userEmail: localStorage.getItem(STORAGE_KEYS.USER_EMAIL) || "",
  };
}

/**
 * @returns {string}
 */
export function getApiBaseUrl() {
  return String(CONFIG.API_BASE_URL || "").trim();
}

export { isApiConfigured };
